/**
 * Logout Button Component
 * Handles user logout
 */

import { LogOut } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import { Button, ButtonProps } from '@/components/Common';

export interface LogoutButtonProps extends Omit<ButtonProps, 'onClick'> {
  showIcon?: boolean;
}

export function LogoutButton({
  showIcon = true,
  variant = 'ghost',
  size = 'md',
  children,
  ...props
}: LogoutButtonProps) {
  const { logout, isLoading } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (err) {
      console.error('Logout failed:', err);
    }
  };

  return (
    <Button
      onClick={handleLogout}
      variant={variant}
      size={size}
      isLoading={isLoading}
      leftIcon={showIcon ? <LogOut className="h-4 w-4" /> : undefined}
      disabled={isLoading}
      {...props}
    >
      {children || 'Sign out'}
    </Button>
  );
}
